export const Saledetail = [
   {
      id:1,
      icon: "icofont icofont-arrow-down font-primary",
      font: "primary",
      day: "Today",
      number: "5698",
      percentage: "-36%($258)"
   },
   {
      id:2,
      icon: "icofont icofont-arrow-down font-secondary",
      font: "secondary",
      day: "Month",
      number: "654",
      percentage: "-15%($369)"
   },
   {
      id:3,
      icon: "icofont icofont-arrow-up font-success",
      font: "success",
      day: "Week",
      number: "647",
      percentage: "+65%($69)"
   },

   {
      id:4,
      icon: "icofont icofont-arrow-up font-danger",
      font: "danger",
      day: "Year",
      number: "918",
      percentage: "+90%($54)"
   },



]
